import Image from 'next/image'
import Button from '#/components/Button'
import { logEvent } from '#/services/analytics'
import styles from '../styles.module.scss'
import { News } from '../types'
import CoverImage from './CoverImage'
import Date from './Date'

export const Avatar = ({ author }: { author: News.Author }) => (
  <div className='flex items-center pb-6 pt-1'>
    <div className={styles['th-author-wrapper']}>
      <span className='sr-only'>{author.node.name}</span>
      <Image
        alt={author.node.name + ' avatar'}
        className='rounded-full object-cover'
        height={38}
        src={author.node.avatar.url}
        style={{ height: 38 }}
        width={38}
      />
    </div>
    <div className='ml-3'>
      <div className='text-sm font-medium text-gray-900'>
        <div className='capitalize hover:underline'>
          {author.node.name}
        </div>
      </div>
    </div>
  </div>
)

export const CardDetails = ({ title, date, author }: News.CardDetailsProps) => (
  <div className={styles['th-details-container']}>
    <div className={styles['th-details']}>
      {date && <Date dateString={date} />}
      {title && (
        <h3
          dangerouslySetInnerHTML={{ __html: title }}
          className={styles['th-title']}
        />
      )}
    </div>
    <Avatar author={author} />
  </div>
)

const NewsCard: React.FC<News.NewsPreviewProps> = ({
  title,
  coverImage,
  date,
  excerpt,
  slug,
  height,
  author
}) => {
  function logCardClick(name: string) {
    logEvent('select_content', {
      content_type: 'news',
      item_id: 'open_post',
      value: `${name}`
    })
  }

  return (
    <a
      className={styles['th-newscard-container']}
      href={excerpt}
      rel='noreferrer'
      target='_blank'
      onClick={() => logCardClick(slug)}
    >
      <div className={styles['th-newscard']}>
        <div className={styles['th-img-wrapper']}>
          <CoverImage
            coverImage={coverImage}
            height={height}
            slug={slug}
            title={title}
          />
        </div>
        <CardDetails author={author} date={date} title={title} />
      </div>

      <div className={styles['th-more-container']}>
        <Button className='rounded-full px-4 py-1.5'>Read More</Button>
      </div>
    </a>
  )
}

export default NewsCard
